import {
  EmailInUseSchoolUserRelation,
  ParentSearchResult,
  StatusUserRelation,
  UserParentOtherAdult,
  UserParentOtherChild,
} from '@schooly/api';
import {
  CreateChildForm,
  CreateCustomField,
  CreateParentForm,
} from '@schooly/components/applications';
import { isNotEmpty } from '@schooly/utils/predicates';

export const convertEmailInUseRelationToParentForm = (
  relation: EmailInUseSchoolUserRelation,
  customFields: CreateCustomField[],
): CreateParentForm => {
  return {
    email: relation.email ?? '',
    profile_id: relation.user_id,
    given_name: relation.given_name ?? undefined,
    last_name: relation.last_name,
    id: relation.user_id,
    title: relation.title ?? undefined,
    primary: false,
    custom_fields: customFields,
    gender: relation.gender === null ? undefined : relation.gender,
    language: relation.language === null ? undefined : relation.language,
    telephone: relation.telephone === null ? undefined : relation.telephone,
    nationalities: relation.nationalities ?? [],
    profession: relation.profession ?? undefined,
  };
};

export const convertExistingAdultToParentForm = (
  adult: ParentSearchResult | StatusUserRelation,
  customFields: CreateParentForm['custom_fields'],
): CreateParentForm => {
  return {
    email: adult?.email ?? '',
    profile_id: adult.user_id,
    given_name: adult.given_name ?? undefined,
    last_name: adult.last_name,
    id: adult.user_id,
    title: adult.title ?? undefined,
    primary: false,
    custom_fields: customFields,
    gender: adult.gender === null ? undefined : adult.gender,
    language: adult.language === null ? undefined : adult.language,
    telephone: adult.telephone === null ? undefined : adult.telephone,
    nationalities: adult.nationalities,
    ...('profession' in adult && { profession: adult?.profession }),
  };
};

export const convertParentOtherAdultToParentForm = (
  adult: UserParentOtherAdult,
  customFields: CreateParentForm['custom_fields'],
): CreateParentForm => {
  return {
    id: adult.adult_id,
    profile_id: adult.adult_id,
    given_name: adult.given_name,
    last_name: adult.last_name,
    email: adult.email ?? '',
    primary: false,
    custom_fields: customFields,
  };
};

export const convertExistingChildToChildForm = (
  child: UserParentOtherChild,
  customFields: CreateChildForm['custom_fields'],
): CreateChildForm => {
  return {
    id: child.user_id,
    gender: child.gender,
    profile_id: child.user_id,
    given_name: child.given_name ?? '',
    last_name: child.last_name ?? '',
    language: isNotEmpty(child.language)
      ? [{ language: child.language, speaking: undefined, writing: undefined }]
      : [],
    school_history: [],
    preferred_start_date: '',
    date_of_birth: child.date_of_birth ?? '',
    nationalities: isNotEmpty(child.nationality) ? [child.nationality] : [],
    custom_fields: customFields,
  };
};

export const convertParentOtherAdultToExistingUser = (adult: UserParentOtherAdult) => {
  return {
    id: adult.adult_id,
    given_name: adult.given_name,
    last_name: adult.last_name,
    profile_picture: adult.profile_picture,
    email: adult.email ?? undefined,
  };
};
